import store from '@/store';

export default function msisdnGuard(to, from, next) {
  if(store.getters.getAuthState != 0 || store.getters.getCustomer.enriched == 2) {
    next()
  } else {
    next('/acesso-negado')
  }
}
